// extracted by mini-css-extract-plugin
export default {"paymentSection":"d9-z","disabled":"e9-z"};